// extracted by mini-css-extract-plugin
export default {"error":"DataRetentionSettings_error__3JP8E","empty":"DataRetentionSettings_empty__rgZM7","table":"DataRetentionSettings_table__vUg5Z"};